import { render, staticRenderFns } from "./select-store-dialog.vue?vue&type=template&id=55fb5ce8"
import script from "./select-store-dialog.vue?vue&type=script&lang=js"
export * from "./select-store-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports